// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__vXUjK","inner":"index_inner__2agfw","trigger":"index_trigger__2i1Ca"};